import { render, staticRenderFns } from "./FormSubmitRecordList.vue?vue&type=template&id=799e2760&scoped=true"
import script from "./FormSubmitRecordList.vue?vue&type=script&lang=js"
export * from "./FormSubmitRecordList.vue?vue&type=script&lang=js"
import style0 from "./FormSubmitRecordList.vue?vue&type=style&index=0&id=799e2760&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799e2760",
  null
  
)

export default component.exports